import ProfileCard from "./Profile";

export default ProfileCard; 